import * as React from 'react';
import styles from './OrderOverviewTermsModal.styl';
// md3: MUI Tabs/Tab -> the md3.css `.st-tabs`/`.st-tab` underline tab bar (plain buttons)
import classNames from 'classnames';
const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    return (React.createElement("div", { role: 'tabpanel', hidden: value !== index, id: `full-width-tabpanel-${index}`, "aria-labelledby": `full-width-tab-${index}`, ...other }, value === index && (React.createElement("div", { className: styles.boxContent }, children))));
};
function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`
    };
}
const OrderOverviewTermsModal = ({ t, language, content: { ourTermsAndConditions }, initialTab }) => {
    const [value, setValue] = React.useState(initialTab || 0);
    // BaseModal keys every instance of this modal by the same string ('ORDER_OVERVIEW_TERMS_MODAL',
    // see onCheckoutModalClick/showModal) regardless of which page trigger opened it, so React can
    // reuse the same component instance across opens rather than remounting it — in which case
    // useState(initialTab)'s own initializer never re-runs, and a later open leaves the tab
    // wherever an earlier open's clicks left it instead of jumping to ITS OWN initialTab (e.g.
    // "Garantiebedingungen" here landing on "Zulassung" because that was the last tab clicked the
    // previous time this same modal was open). Re-sync whenever the prop actually changes.
    React.useEffect(() => {
        setValue(initialTab || 0);
    }, [initialTab]);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const handleChangeIndex = (index) => {
        setValue(index);
    };
    // NEED TO DELETE
    const tabNames = [
        'ourTermsConditions',
        'admission',
        'warrantyConditions'
    ];
    // NEED TO DELETE
    const modalWrapperClasses = classNames(styles.modalWrapper, { [styles.modalWrapperEn]: language === 'en' });
    return (React.createElement("div", { className: modalWrapperClasses },
        React.createElement("div", { className: classNames(styles.appBar, 'ootm-appbar') },
            React.createElement("div", { role: 'tablist', className: 'st-tabs', "aria-label": 'full width tabs example' }, tabNames.map((name, index) => (React.createElement("button", { type: 'button', role: 'tab', key: index, "aria-selected": value === index, className: classNames('st-tab', styles.tabs, { 'is-active': value === index }), onClick: (event) => handleChange(event, index), ...a11yProps(index) }, t(`CheckoutPage:modals.orderOverviewTerms.title.${name}`)))))),
        tabNames.map((name, index) => (React.createElement(TabPanel, { key: index, value: value, index: index },
            React.createElement("span", { className: styles.tabContent }, index === 0 ? React.createElement("div", { dangerouslySetInnerHTML: { __html: ourTermsAndConditions } }) : t(`CheckoutPage:modals.orderOverviewTerms.${name}`)))))));
};
export default OrderOverviewTermsModal;
